if (!window.UOCurrencyEstimateNoticeInitialized) {
  window.UOCurrencyEstimateNoticeInitialized = true;
  const getCurrency = () => {
    const selector = document.querySelector('.edge-currency-switcher__select');
    const selected = selector?.getAttribute('data-value') || selector?.value ||
      document.querySelector('.edge-currency-switcher__value')?.textContent;
    const code = selected?.trim().toUpperCase();
    return /^[A-Z]{3}$/.test(code || '') ? code : '';
  };
  let frame;
  const updateNotices = () => {
    window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(() => {
      const selected = getCurrency();
      document.querySelectorAll('[data-currency-estimate-notice]').forEach((notice) => {
        const currency = selected || notice.dataset.shopCurrency;
        const code = notice.querySelector('[data-currency-code]');
        if (code && code.textContent !== currency) code.textContent = currency;
        const hidden = !currency || currency === 'EUR';
        if (notice.hidden !== hidden) notice.hidden = hidden;
        notice.classList.remove('hidden');
      });
    });
  };
  const observer = new MutationObserver(updateNotices);
  observer.observe(document.body, {
    childList: true, subtree: true, characterData: true,
    attributes: true, attributeFilter: ['data-value'],
  });
  document.addEventListener('change', updateNotices);
  document.addEventListener('cart:update', updateNotices);
  window.addEventListener('pageshow', updateNotices);
  updateNotices();
}
